import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Filters {
  vehicle?: string;
  driver?: string;
}

export type DataState = {
  error: any;
  reports: any[];
  isLoadingReports: boolean;
  isRefreshData: boolean;
  dataTotalCount: number;
  dataCurrentCount: number;

  filters?: Filters;
};

const initialState: DataState = {
  error: null,
  reports: [],
  isLoadingReports: false,
  isRefreshData: false,

  dataTotalCount: 0,
  dataCurrentCount: 0,

  filters: {},
};

export const ReportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    loadReports(state, action: PayloadAction<any>) {
      state.reports = action.payload;
    },
    setLoadingReports(state, action: PayloadAction<any>) {
      state.isLoadingReports = action.payload;
    },
    setRefreshData(state, action: PayloadAction<any>) {
      state.isRefreshData = action.payload;
    },

    setTotalCountData(state, action: PayloadAction<any>) {
      state.dataTotalCount = action.payload;
    },
    setCurrentCountData(state, action: PayloadAction<any>) {
      state.dataCurrentCount = action.payload;
    },

    setFilters(state, action: PayloadAction<any>) {
      state.filters = action.payload;
    },
  },
});

export default ReportSlice.reducer;
